// removed by extract-text-webpack-plugin
module.exports = {"headerImage":"src-templates----page-home-module---headerImage---11cq4","wrapper":"src-templates----page-home-module---wrapper---3eJxj"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/page.home.module.css
// module id = 731
// module chunks = 214740112983436